import { t } from 'i18next'
import React, { useCallback, useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { currencyFormatDecimal, formatDate } from '../../utility/Helpers'
import { Pagination } from '../../components/Main'
import { InteractorReturnHistoryView, InteractorReturnSummaryList } from '../../interactors/Main'
import InteractorReturnHistoryList from '../../interactors/return/history/InteractorReturnHistoryList'

const ReturnCheckSaldo = () => {
  const { account } = useSelector((state) => state.account)
  const { returnSummaryList } = InteractorReturnSummaryList()
  const { returnHistoryView } = InteractorReturnHistoryView()
  const { returnHistoryList } = InteractorReturnHistoryList()
  const [returnDataList, setReturnDataList] = useState([])
  const [returnTotal, setReturnTotal] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingHistory, setLoadingHistory] = useState(false)
  const [show, setShow] = useState(false)
  const [pagination, setPagination] = useState()
  const [modalPagination, setModalPagination] = useState()

  const [payloadReturnSummaryList, setPayloadReturnSummaryList] = useState({
    page: 1,
    limit: 5,
    keywords: {
      text_search: '',
      status: '',
      account_uid: account?.uid,
      store_uid: '',
      uid: '',
      transaction_uid: '',
    },
  })

  const [payloadReturnHistory, setPayloadReturnHistory] = useState({
    page: 1,
    limit: 5,
    keywords: {
      customer_account_uid: '',
      store_uid: '',
    },
  })

  const [modalDetailData, setModalDetailData] = useState()
  const [modalDataList, setModalDataList] = useState([])
  const handleReturnSummaryList = useCallback((response) => {
    if (response?.items) {
      const data = response?.items
      setReturnDataList(data)
      setPagination(response.pages)
      setReturnTotal(response.total_retur)
    } else {
      setReturnDataList([])
    }
  }, [])

  useEffect(() => {
    if (loading) {
      returnSummaryList(payloadReturnSummaryList, handleReturnSummaryList, setLoading)
    }
  }, [returnSummaryList, loading, payloadReturnSummaryList, handleReturnSummaryList])

  const showModal = () => {
    setShow((prev) => !prev)
  }

  const showDetail = (row) => {
    const payloadView = {
      customer_account_uid: account?.uid,
      store_uid: row?.store_uid,
    }

    setPayloadReturnHistory((prev) => ({ ...prev, keywords: payloadView }))
    setLoadingHistory(true)
    returnHistoryView(
      payloadView,
      (items) => {
        setModalDetailData({
          ...items,
          store_name: row.store_name,
        })
      },
      setLoadingHistory,
    )
    showModal()
  }

  const handleReturnHistoryList = useCallback((response) => {
    if (response?.items) {
      const data = response?.items
      setModalDataList(data)
      setModalPagination(response.pages)
    } else {
      setModalDataList([])
    }
  }, [])

  useEffect(() => {
    if (loadingHistory) {
      returnHistoryList(payloadReturnHistory, handleReturnHistoryList, setLoadingHistory)
    }
  }, [returnHistoryList, loadingHistory, payloadReturnHistory, handleReturnHistoryList])

  const onPageChange = (newPage) => {
    setPayloadReturnSummaryList((prev) => ({ ...prev, page: newPage }))
    setLoading(true)
  }

  const onLimitChange = (newLimit) => {
    setPayloadReturnSummaryList((prev) => ({ ...prev, limit: newLimit, page: 1 }))
    setLoading(true)
  }

  const onModalPageChange = (newPage) => {
    setModalPagination((prev) => ({ ...prev, newPage }))
    setPayloadReturnHistory((prev) => ({ ...prev, page: newPage }))
    setLoadingHistory(true)
  }

  const onModalLimitChange = (newLimit) => {
    const limit = parseInt(newLimit)
    setPagination((prev) => ({ ...prev, limit, page: 1 }))
    setPayloadReturnHistory((prev) => ({ ...prev, limit, page: 1 }))
    setLoadingHistory(true)
  }

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between mb-2">
        <h5 className="text-primary fw-bold p-2 m-0">{t('title.return_saldo')}</h5>
        <Link
          to={'#'}
          onClick={() => {
            window.location = `/return`
          }}
          className="text-dark btn-outline-secondary btn btn-xs m-2 font-size-12"
        >
          <i className="fas fa-arrow-left px-2"></i> {t('button.back')}
        </Link>
      </div>
      <hr className="m-0" />
      <div className="card p-3 mt-3 mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6>{t('title.return_history.title')}</h6>

          <div className="d-flex align-items-center">
            <div className="mx-3">
              <i
                className="fas fa-money-bill-wave text-success"
                style={{ fontSize: '24px', opacity: 0.8 }}
              ></i>
            </div>

            <div className="d-flex flex-column">
              <span className="text-secondary font-size-9 fw-bold mb-1" style={{ lineHeight: '1' }}>
                {t('title.return_total')}
              </span>
              <span className="text-primary fw-bold font-size-16" style={{ lineHeight: '1.2' }}>
                <b>{currencyFormatDecimal(returnTotal ?? 0)}</b>
              </span>
            </div>
          </div>
        </div>

        <table className="table table-responsive table-borderless table-scrollable">
          <thead className="border-bottom text-uppercase small">
            <tr>
              <th className="col-2">#</th>
              <th className="col-2">{t('title.return_history.store_name')}</th>
              <th className="col-2">{t('title.return_history.nominal_return_available')}</th>
              <th className="col-2">{t('title.return_history.nominal_return_used')}</th>
              <th className="col-2">{t('title.action')}</th>
            </tr>
          </thead>
          <tbody>
            {returnDataList?.length ? (
              returnDataList?.map((item, index) => (
                <tr key={`data-${index}`} className="font-size-13">
                  <td className="text-secondary"></td>
                  <td className="text-secondary fw-medium">{item.store_name ?? '-'}</td>
                  <td className="text-center text-secondary">
                    {currencyFormatDecimal(item?.retur_available ?? 0)}
                  </td>
                  <td className="text-center text-secondary">
                    {currencyFormatDecimal(item?.retur_used ?? 0)}
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-primary btn-xs rounded-pill px-3 font-size-11"
                      onClick={() => showDetail(item)}
                    >
                      {t('button.view')}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center">
                  {t('title.no_data')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="container mt-4">
        <Pagination data={pagination} onChangePage={onPageChange} onLimitChange={onLimitChange} />
      </div>

      <Modal open={show} onClose={showModal}>
        <div className="container-fluid mx-0">
          <div className="row justify-content-start p-2 mb-4">
            <h5 className="font-weight-bold">{t('title.return_saldo_detail')}</h5>
          </div>

          <div className="align-items-center mb-4">
            <p className="text-secondary mb-1 h4">
              {t('title.return_history.nominal_return_available')}
            </p>
            <p className="h4 bold">
              {modalDetailData?.total_retur_available
                ? currencyFormatDecimal(modalDetailData?.total_retur_available)
                : '-'}
            </p>
          </div>

          <div className="row align-items-baseline">
            <div className="col-6 mb-3">
              <div>
                <strong>{t('title.return_history.store_name')}</strong> <br />
                {modalDetailData?.store_name ?? '-'}
              </div>
            </div>
            <div className="col-6 mb-3">
              <div>
                <strong>{t('title.return_history.nominal_return_used')}</strong> <br />
                {modalDetailData?.total_retur_used
                  ? currencyFormatDecimal(modalDetailData?.total_retur_used)
                  : '-'}
              </div>
            </div>
            <div className="col-6 mb-3">
              <div>
                <strong>{t('title.return_total')}</strong> <br />
                {modalDetailData?.total_retur_amount
                  ? currencyFormatDecimal(modalDetailData?.total_retur_amount)
                  : '-'}
              </div>
            </div>
            <div className="col-6 mb-3">
              <div>
                <strong>{t('title.return_history.nominal_return_request')}</strong> <br />
                {modalDetailData?.total_retur_request
                  ? currencyFormatDecimal(modalDetailData?.total_retur_request)
                  : '-'}
              </div>
            </div>
            <div className="col-12 my-3">
              <hr className="m-0" />
            </div>
            <div className="col-12">
              <h6 className="mb-2">
                <strong>{t('title.return_order_history')}</strong>
              </h6>
              <div className="card mt-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <div className="table-responsive">
                  <table className="table align-middle mb-0 w-100">
                    <thead
                      className="bg-light text-center font-size-14"
                      style={{ position: 'sticky', top: 0, zIndex: 10 }}
                    >
                      <tr>
                        <th>{t('form.created_date')}</th>
                        <th>{t('title.return_history.reference_number')}</th>
                        <th>{t('title.return_history.total')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {modalDataList?.length ? (
                        modalDataList.map((item, index) => (
                          <tr key={`data-${index}`} className="text-center">
                            <td>{formatDate(item.created_date, 'DD-MM-YYYY')}</td>
                            <td>{item.retur_reference}</td>
                            <td
                              className={`fw-bold ${
                                item.retur_type === 'PLUS' ? 'text-success' : 'text-danger'
                              }`}
                            >
                              {item.retur_type === 'PLUS' ? '+' : '-'}{' '}
                              {currencyFormatDecimal(Math.abs(item.retur_amount))}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            {t('title.no_data')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="container mt-4">
                <Pagination
                  data={modalPagination}
                  onChangePage={onModalPageChange}
                  onLimitChange={onModalLimitChange}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ReturnCheckSaldo
